import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "react-bootstrap/Table";
import { Button } from "@mui/material";
import { getCommissionPayment } from "../../store/reducers/affiliateReducer";
import searchicon from "../../assets/icons/searchIcon.svg";
import TickIcon from "../../assets/icons/tick-close.svg";
import crossIcon from "../../assets/icons/circle-close.svg";
import progressIcon from "../../assets/icons/progress-cricle.svg";
import dayjs from "dayjs";
import PaginationComponent from "../../utilities/Pagination";
import MobileTabs from "../../reusableComponents/MobileTabs/MobileTabs";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Loader from "../../reusableComponents/Loader";
import toast from "react-hot-toast";
import ReactTable from "../../components/ReactTable/ReactTable";

const CommissionPayment = () => {
  const dispatch = useDispatch();
  const { commission_payment } = useSelector((state) => state.affiliate);
  const selectedAffiliate = useSelector(
    (state) => state.affiliate.selectedAffiliate
  );

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [statusFilter, setStatusFilter] = useState("All");
  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(loader);
  const [activeTab, setActiveTab] = useState(statusFilter);

  const [params, setParams] = useState({
    page: 1,
    page_size: 10,
    search: "",
  });

  useEffect(() => {
    setOpen(loader);
  }, [loader]);

  useEffect(() => {
    dispatch(getCommissionPayment(params));
  }, [params]);

  useEffect(() => {
    setParams({
      ...params,
      page: currentPage,
      page_size: pageSize,
      search,
    });
  }, [search, currentPage, pageSize, statusFilter]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFilterChange = (newFilter) => {
    setStatusFilter(newFilter);
    setCurrentPage(1);
  };

  const handleCopyToClipboard = (url) => {
    toast.success("Affiliate link copied.", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      className: "custom-toast-container",
    });
  };

  const formatDate = (dateString) =>
    dayjs(dateString).format("DD MMM, YYYY HH:mm");

  const dollarUS = (amount) => `$${parseFloat(amount)?.toFixed(2)}`;

  const totalPages = commission_payment?.count
    ? Math.ceil(commission_payment?.count / pageSize)
    : 0;

  const filteredData = commission_payment?.results || [];

  const tabItems = [
    { name: "All", value: "All" },
    { name: "Paid", value: "Paid" },
    { name: "Pending", value: "Pending" },
    { name: "Failed", value: "Failed" },
  ];

  useEffect(() => {
    setStatusFilter(activeTab);
  }, [activeTab]);

  return (
    <div
      id="commission-payment-table"
      className="LeaderboardPage PaymentHistoryPage affiliateTable"
      style={{ position: "relative", width: "100%" }}
    >
      {<Loader open={open} />}
      <div className="HistoryDesk">
        <div className="table_header">
          <div className="table_header_left">
            <div className="search_bar_wrapper">
              <img src={searchicon} alt="searchicon" />
              <input
                type="text"
                style={{ borderRadius: "0px" }}
                className="search_input"
                placeholder="Search by URL..."
                value={search}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        </div>

        {filteredData.length ? (
          <>
            <div className="affiliateTableContainer">
              <ReactTable
                columns={[
                  {
                    Header: "Date",
                    accessor: "created_at",
                    width: 200,
                    Cell: ({ value }) => formatDate(value),
                  },
                  {
                    Header: "Commission %",
                    accessor: "commission_percentage",
                    width: 200,
                    Cell: ({ value }) =>
                      value !== undefined && value !== null
                        ? `${Number(value).toFixed(2)}%`
                        : "N/A",
                  },
                  {
                    Header: "Amount",
                    accessor: "amount",
                    width: 200,
                    Cell: ({ value }) => dollarUS(value),
                  },
                  {
                    Header: "URL",
                    accessor: "affiliate_code",
                    width: 250,
                    Cell: ({ value }) =>
                      value ? (
                        <div className="aff_code_url">
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                `https://app.alphacapitalgroup.uk/signup/${value}/`,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }}
                            title={`https://app.alphacapitalgroup.uk/signup/${value}/`}
                            style={{
                              color: "#F6F6F6",
                              fontWeight: "500",
                              cursor: "pointer",
                            }}
                          >
                            {`https://app.alphacapitalgroup.uk/signup/${value}/`
                              .length > 20
                              ? `${`https://app.alphacapitalgroup.uk/signup/${value}/`.substring(
                                  0,
                                  20
                                )}...`
                              : `https://app.alphacapitalgroup.uk/signup/${value}/`}
                          </span>
                          <CopyToClipboard
                            text={`https://app.alphacapitalgroup.uk/signup/${value}/`}
                            onCopy={() => handleCopyToClipboard(value)}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="copy_icon"
                              style={{ cursor: "pointer", marginLeft: "8px" }}
                            >
                              <path
                                d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z"
                                fill="#B0B0B0"
                              />
                            </svg>
                          </CopyToClipboard>
                        </div>
                      ) : (
                        <span>N/A</span>
                      ),
                  },
                ]}
                data={filteredData}
                manualPagination={true}
                page={currentPage}
                pageSize={pageSize}
                onPageChange={setCurrentPage}
                onPageSizeChange={setPageSize}
                totalCount={commission_payment?.count || 0}
              />
            </div>
          </>
        ) : (
          <p>No data available.</p>
        )}
      </div>
    </div>
  );
};

export default CommissionPayment;
